/*jshint esversion: 6 */

import {checkoutFile, microCartRemoveItem, directInquiry, attemptStoringCustomerDetails} from "./ecommerce";
import {searchCompany} from "./brreg";
import browserIntent from "./browser-intent";

document.addEventListener('DOMContentLoaded', () => {
  microCartRemoveItem();
  checkoutFile();
  directInquiry();
  //browserIntent();
  searchCompany();
  attemptStoringCustomerDetails();
  contactPopup();
});

function contactPopup() {
  const contactTrigger = document.querySelector('.contact-trigger-wrapper');
  const contactPopup = document.querySelector('.mobile-contact-wrapper');
  if(!contactTrigger || !contactPopup) {
    return;
  }
  contactTrigger.addEventListener('click', (e) => {
    e.preventDefault();
    contactPopup.classList.toggle('active');
  });
}

//variations_form
jQuery(document).ready(function ($) {
    var quoteValue = $('.wishlist_products_counter_number');
    // if(quoteValue.html() > 0) {
    //   quoteValue.fadeIn();
    // }



    var onScrollStickyImage = function (e) {
    var offsetLock = 20;
    var widthLock = 1200;

    var sY = $(window).scrollTop();
    var wI = window.innerWidth;
    var productContainer = !!document.querySelector('.single-product .product') ? $('.single-product .product') : null; // the page must have a product container

    if (productContainer !== null) {
      var imageContainer = productContainer.find('.custom-image-outer-wrapper').first(); // the outer wrapper for the image
      var image = productContainer.find('.single-product-main-image').first(); // image, the actual image that we need to sticky
      var imageHeight = image.outerHeight(); // height of the image

      var wabHeight = typeof $('#wpadminbar') !== "undefined" ? $('#wpadminbar').outerHeight() : 0; // calculates the wp admin bar height
      var headerHeight = $('#header').outerHeight() + parseInt($('#header').css('margin-top')); // headerheight of the top header, with menu

      var productOffset = productContainer.offset().top; // the offset position of the product container from top
      var productOffsetBottom = productOffset + productContainer.outerHeight(); // this is the bottom position of the product container, changes when the elements in it are expanded and collapsed //) - headerHeight - image.outerHeight();


      var fixLock = wabHeight + headerHeight + offsetLock;
      var absLock = productOffsetBottom - wabHeight - imageHeight - offsetLock;

      if (sY > fixLock && sY < absLock && wI >= widthLock) { // scrolled under header, element is set to fixed, scroll position has to be higher than the fix lock but lower than the abslock
        image.css({
          'width': imageContainer.width() + 'px',
          'height': image.outerHeight() + 'px',
          'margin-top': offsetLock + 'px',
          'margin-bottom': '0',
          'position': 'fixed',
          'top': headerHeight + wabHeight + 'px',
        });
      } else if (sY > absLock && wI >= widthLock) { // scrolled past the product information
        image.css({
          'height': image.outerHeight() + 'px',
          'margin-bottom': '0',
          'position': 'absolute',
          'top': 'auto',
          'bottom': '0',
        });
      } else { // scrolled back to top
        image.css({
          'position': 'static',
          'width': '100%',
          'top': 'auto',
        });
      }
    }
  };

  if (!!document.querySelector('.single-product .product')) {
    window.addEventListener('scroll', onScrollStickyImage, {
      passive: true
    });
  }

  // var awl = $('.tinvwl-after-add-to-cart');
  // awl.hide();

  // $('.tm-toggle').on('click', function () {
  //   var awl = $('.tinvwl-after-add-to-cart');
  //   if ($(this).hasClass('toggle-header-closed')) {
  //     awl.show();
  //   } else {
  //     awl.hide();
  //   }
  // });

  // if ($('.tm-collapse-wrap').hasClass('closed')) {
  //   awl.hide();
  // } else {
  //   awl.show();
  // }

//  $('.tinvwl-after-add-to-cart').show();

  $('.expand-text').on('click', function () {
    $(this).fadeOut(50).closest('.main').next('.extended').slideDown();
  });

  $('.show-product-info').on('click', function () {
    $('.product-info').find('.single-accordion-heading').addClass('active-toggle').next('.content-box').show();
    $([document.documentElement, document.body]).animate({
      scrollTop: $('.product-info').offset().top - $('#header_main').outerHeight() - 70
    }, 250);
  });

  var copyQuoteValues = function () {
    let itgo = this;
    const sourceContainer = $('.tinvwl-table-manage-list');

    let productArray = [];
    //let tableWrapper = $('<table width="100%"></table>');
    let tableWrapper = '<table width="100%">';

    if (sourceContainer.length > 0) {
      sourceContainer.find('td.product-name').each(function () {
        let itgo = $(this);
        let productWrapper = '';
        let productItem = '';
        let productName = `${itgo.find('a').text()}`;
        let link = itgo.find('a').attr('href');
        let imgSrc = itgo.parent().find('td.product-thumbnail a img').attr('src');
        let imgTag = `<td width="125"><a href="${link}"><img width="125" height="125" src="${imgSrc}" /></a></td>`;
        let productOptions = itgo.find('.variation');
        let productVariants = [];
        
        productWrapper = '<tr valign="top">' + imgTag;

        productOptions.find('dt').each(function () {
          let variant = '';
          variant = `<strong>${$(this).text()}</strong> ${$(this).next('dd').text()}<br />`;
          productVariants.push(variant);
        });

        productWrapper = productWrapper + `<td><a href="${link}"><strong>${productName}</strong></a> <br />\n ${productVariants.join("\n")} <br /><br />\n</td></tr>`;
        tableWrapper = tableWrapper + productWrapper;
        //productArray.push(productItem);
      });
      tableWrapper = tableWrapper + '</table>';
      // productWrapper.append(imgTag).append($("<tr>" + productArray.join("\n") + "</tr>"));
      // tableWarpper.append(productWrapper);
      //console.log(tableWrapper);

      $('.order-info textarea').val(tableWrapper);
    }
  };


  copyQuoteValues();

  $(document).on('gform_confirmation_loaded', function(event, formId){
    if(formId == 1) {
      var containerId = $('.tinv-wishlist form');
      var uriString = containerId.attr('action').replace(/\/$/, "");
      var wishlistID = uriString.substring(uriString.lastIndexOf('/') + 1);

      $.ajax({
        url: "/wp-json/wishlist/v1/delete/",
        data: $.param({id: wishlistID}),
        context: document.body
      }).done(function(data) {
        for (var key in sessionStorage) {
          if (key.indexOf("ti_wishlist_data") === 0) {
            sessionStorage.removeItem(key);
          }
        }
        for (var key in localStorage) {
          if (key.indexOf("ti_wishlist_data") === 0) {
            localStorage.removeItem(key);
          }
        }
        $('.wishlist_products_counter_number').html('0');
        $('.wishlist_item').each(function() {
          $(this).fadeOut(200, function() { $(this).remove(); });
        });
      }).fail(function(xhr, status, error) {
        //console.log(status);
      });
    } else {
      //console.log("Any other form confirmed")
    }
  });

  if($('#tinvwl_product_actions').length) {
    $('#tinvwl_product_actions').val('remove');
  }

});